///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.promos = abcsetup.promos || {};
abcsetup.promos.items = abcsetup.promos.items || {};
abcsetup.promos.items.index = abcsetup.promos.items.index || {};




///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.promos.items.index = {
    promo_id: null,
    fieldsInit: function() {
        $(document).on('click','#reject_approved_item', function () {
            var numberOfChecked = $('input.reject_approved_item:checked').length;
            if (numberOfChecked) {
                abcsetup.blockUI(true);
                var fields = $('form#promotion_item').serialize();
                axios.post('/api/promos/reject_approved_item',fields).then( response => {
                    location.reload();
                });
            }
        });


        $(document).on('click','input.reject_approved_item', function () {
            $(this).closest(".reject_approve_item").find(".reject_approve_item_reason").toggle();
        });
    }
}